import { useState, useEffect, useRef } from "react";
import { AnimatePresence } from "framer-motion";
import LogoAnimation from "../../atoms/LogoAnimation";
import { HamburgerMenuButton, NavButtonSearch } from "../../atoms/Buttons";
import MenuOverlay from "../../atoms/MenuOverlay";
import MenuModalLarge from "./MenuModalLarge";
import MenuModalSmall from "./MenuModalSmall";

export default function MainNav({
  scrollTrigger,
  setSearchOpen,
  searchOpen,
  menuItems,
  openModal,
  setOpenModal,
  openModalSmall,
  setOpenModalSmall,
  menuItemsSecondary,
  websiteType,
  tablet_image,
}) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [modalSmallActiveItem, setModalSmallActiveItem] = useState(null);
  const menuOverlayRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpenModal(null);
      }
    };

    const handleClickOutside = (event) => {
      if (
        menuOverlayRef.current &&
        menuOverlayRef.current.contains(event.target)
      ) {
        setOpenModal(null);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="relative z-10">
        <div
          className={`container-custom bg-gray-200 border-b duration-300 ${
            !searchOpen &&
            scrollPosition < scrollTrigger &&
            !openModal &&
            !openModalSmall
              ? "border-transparent"
              : "border-gray-300"
          }`}
        >
          <div className="flex justify-between h-[52px] w-full items-center">
            <nav className="relative flex items-center gap-x-60 h-full">
              <LogoAnimation
                scrollPosition={scrollPosition}
                scrollTrigger={scrollTrigger}
                websiteType={websiteType}
                setOpenModal={setOpenModal}
                setOpenModalSmall={setOpenModalSmall}
              />
              {/* Submenu Desktop */}
              <MenuModalLarge
                menuItems={menuItems}
                openModal={openModal}
                setOpenModal={setOpenModal}
                setSearchOpen={setSearchOpen}
              />
            </nav>
            <div className="flex items-center gap-x-30 h-full">
              {/* <NavButtonSearch
                onClick={() => {
                  setSearchOpen(true);
                  setOpenModal(null);
                }}
              /> */}
              <HamburgerMenuButton
                text="Menu"
                onClick={() => {
                  setOpenModalSmall(!openModalSmall);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Submenu Small */}
      <MenuModalSmall
        openModalSmall={openModalSmall}
        setOpenModalSmall={setOpenModalSmall}
        modalSmallActiveItem={modalSmallActiveItem}
        setModalSmallActiveItem={setModalSmallActiveItem}
        menuItems={menuItems}
        menuItemsSecondary={menuItemsSecondary}
        tablet_image={tablet_image}
      />
      <AnimatePresence>
        {openModal && (
          <div key="main-nav-overlay" ref={menuOverlayRef}>
            <MenuOverlay />
          </div>
        )}
      </AnimatePresence>
    </>
  );
}
